import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    allAvailableMccList: [],
    allAvailableMccCategories: [],
    mccBlockData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getAllAvailableMccsList = createAsyncThunk(
    "mcc block management/available mcc list",
    async ({ user, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getMcCodes;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.post(apiURL, search);
            return { ...response?.data, status: response.status };
        } catch (error) {
            throw error.response;
        }
    }
);

export const getAllMccBlockList = createAsyncThunk(
    "mcc block management/global or participant mcc block list",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            // const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getBlockedMCC;

            const apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;

            const response = await axiosInstance.post(apiURL, search);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddUpdateMccBlock = createAsyncThunk(
    "mcc block management/add update mcc block",
    async ({ user, body, update }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.saveMakerBlockedMcc;

            const apiURL = base + endpointpath;

            // const method = update ? 'put' : 'post';
            // const response = await axiosInstance[method](apiURL, body);
            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postRemoveMccBlock = createAsyncThunk(
    "mcc block management/remove mcc block",
    async ({ user, body }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.saveMakerBlockedMcc;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const mccBlockSlice = createSlice({
    name: "MCC Blocks",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL AVAILABLE MCCs LIST
            .addCase(getAllAvailableMccsList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.allAvailableMccList = [];
                state.allAvailableMccCategories = [];
            })
            .addCase(getAllAvailableMccsList.fulfilled, (state, action) => {
                state.loading = false;
                state.allAvailableMccCategories = action?.payload?.data ? action?.payload?.data?.map(({ type }) => ({ label: type, value: type })) : [];
                state.allAvailableMccList = action?.payload?.data ? action?.payload?.data?.flatMap(({ merchants }) => merchants) : [];
            })
            .addCase(getAllAvailableMccsList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // GET ALL MCC BLOCK LIST
            .addCase(getAllMccBlockList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.mccBlockData = [];
            })
            .addCase(getAllMccBlockList.fulfilled, (state, action) => {
                const { resp, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.mccBlockData = resp || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages };
            })
            .addCase(getAllMccBlockList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD UPDATE MCC BLOCK
            .addCase(postAddUpdateMccBlock.pending, (state) => {
                state.error = null;
            })
            .addCase(postAddUpdateMccBlock.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddUpdateMccBlock.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // REMOVE MCC BLOCK
            .addCase(postRemoveMccBlock.pending, (state) => {
                state.error = null;
            })
            .addCase(postRemoveMccBlock.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postRemoveMccBlock.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default mccBlockSlice.reducer;